import { render, staticRenderFns } from "./FeeExternalVoucherComponent.vue?vue&type=template&id=33f65a75&"
import script from "./FeeExternalVoucherComponent.vue?vue&type=script&lang=js&"
export * from "./FeeExternalVoucherComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports